const resources = {
    exclusiveOffers: 'Offres exclusives'
};

export default function getResource(label) {
    return resources[label];
}
